import React, { useState } from "react";
import { toPersianNum, toSeperatedNum, toEnglishNum } from "../../assets/utils";
import {
  PickerContainer,
  Picker,
  PickerTop,
  PickerMain,
  PickerBottom,
} from "./numberPicker.styles";
const NumberPicker = ({ setPickerSelectedAmount }) => {
  const [pickerAmountState, setPickerAmountState] = useState(1);
  const PickerAmountsArray = [10000, 20000, 50000, 100000];
  const handleUpAmount = () => {
    if (pickerAmountState < 3) {
      setPickerAmountState(pickerAmountState + 1);
      setPickerSelectedAmount(PickerAmountsArray[pickerAmountState + 1]);
    }
  };
  const handleDownAmount = () => {
    if (pickerAmountState > 0) {
      setPickerAmountState(pickerAmountState - 1);
      setPickerSelectedAmount(PickerAmountsArray[pickerAmountState - 1]);
    }
  };
  return (
    <Picker>
      <PickerContainer>
        <PickerTop onClick={handleDownAmount}>
          {pickerAmountState > 0
            ? `${toSeperatedNum(
                toPersianNum(PickerAmountsArray[pickerAmountState - 1])
              )}   تومان   `
            : ""}
        </PickerTop>
        <PickerMain>
          {toSeperatedNum(toPersianNum(PickerAmountsArray[pickerAmountState]))}{" "}
          تومان
        </PickerMain>
        <PickerBottom onClick={handleUpAmount}>
          {pickerAmountState < 3
            ? `${toSeperatedNum(
                toPersianNum(PickerAmountsArray[pickerAmountState + 1])
              )}   تومان   `
            : ""}
        </PickerBottom>
      </PickerContainer>
    </Picker>
  );
};

export default NumberPicker;
